import {
  accountNumberPattern,
  emailPattern,
  trusteeNamePattern,
} from './sharedPattern';

export const seValidation = {
  accountNumber: {
    maxLength: 10,
    minLength: 7,
    pattern: accountNumberPattern,
    required: true,
    translationPrefix:
      'category.disbursement-account.account-number.validation-error',
  },
  accountPrefix: {
    maxLength: 5,
    minLength: 4,
    translationPrefix:
      'category.disbursement-account.clearing-number.validation-error',
  },
  email: {
    pattern: emailPattern,
    required: true,
    translationPrefix: 'category.contact-info.email.validation-error',
  },
  phoneNumber: {
    maxLength: 15,
    minLength: 5,
    required: true,
    translationPrefix: 'category.contact-info.phone.validation-error',
  },
  trusteeName: {
    pattern: trusteeNamePattern,
    required: true,
    translationPrefix:
      'category.personal-bankruptcy.trustee.name.validation-error',
  },
  trusteePhone: {
    maxLength: 15,
    minLength: 5,
    required: true,
    translationPrefix:
      'category.personal-bankruptcy.trustee.phone.validation-error',
  },
  withdrawalAmount: {
    required: true,
    translationPrefix: 'category.autogiro.withdrawal-amount.validation-error',
  },
  withdrawalDate: {
    required: true,
    translationPrefix: 'category.autogiro.withdrawal-date.validation-error',
  },
};
